import { render } from "./KeyAdvantages.vue?vue&type=template&id=438b977b&scoped=true"
import script from "./KeyAdvantages.vue?vue&type=script&lang=js"
export * from "./KeyAdvantages.vue?vue&type=script&lang=js"

import "./KeyAdvantages.vue?vue&type=style&index=0&id=438b977b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438b977b"]])

export default __exports__